import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { FC, PropsWithChildren } from "react";

interface GameDraggableProps extends PropsWithChildren {
  id: string;
  hostedBy: string;
  disabled: boolean;
}

export const GameDraggable: FC<GameDraggableProps> = ({
  children,
  id,
  hostedBy,
  disabled,
}) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: id,
      data: {
        hostedBy: hostedBy,
      },
      disabled: disabled,
    });
  const style = transform
    ? {
        transform: CSS.Translate.toString(transform),
      }
    : undefined;

  return (
    <Paper
      variant="draggable"
      elevation={disabled ? 1 : 3}
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      sx={{
        zIndex: isDragging ? 1000 : 0,
      }}
    >
      <Grid container alignItems="center" height="100%" justifyContent="center">
        <GameDraggableDecoration />
        <Typography variant="body1" textAlign="center">
          {children}
        </Typography>
      </Grid>
    </Paper>
  );
};

const GameDraggableDecoration = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "0.5em",
  left: "0.5em",
  borderColor: theme.palette.secondary.main,
  borderWidth: "3px 0px 0px 3px",
  borderStyle: "solid",
  height: "19px",
  width: "19px",
}));
